import ListTransform from '@model/list/ListTransform'
import Locale from '@serv/Locale'
import ResourceService from '@serv/ResourceService'
import store from '@src/store/index'

class ListTransformCarePeriodFacility extends ListTransform {
    constructor(object) {
        super(object)
        this.filterKey = 'carePeriodFacility'
    }

    get getFilterComponent() {
        return 'DataFilterStringArray'
    }

    get getFilterConfig() {
        const providers = ResourceService.getPatientListProviders()
        const owner = store.state.user.owner
        const title = Locale.getLanguageItem(this.column.label)

        if (!providers || !owner) {
            return { title, valueLabels: [] }
        }

        const keyDatesConfig = owner.getPatientPageTabCptConfig('TabCptAdminDates')
        const carePeriodFacilities = this._getCarePeriodFacilities(keyDatesConfig)

        if (carePeriodFacilities.length === 0) {
            return { title, valueLabels: [] }
        }

        const valueLabels = providers
            .filter(provider => carePeriodFacilities.includes(provider.slug))
            .map(provider => ({
                value: provider.title,
                label: provider.title
            }))
            .sort((a, b) => a.label.localeCompare(b.label))

        return { title, valueLabels }
    }

    _getCarePeriodFacilities(keyDatesConfig) {
        const { eventTypeToPeriodTypeSlugs, periodTypeToProviderSlugs } = keyDatesConfig || {}

        if (!periodTypeToProviderSlugs) {
            return []
        }

        const facilityTypes = eventTypeToPeriodTypeSlugs?.facilityType

        return facilityTypes
            ? this._getFilteredProviderSlugs(periodTypeToProviderSlugs, facilityTypes)
            : this._getAllProviderSlugs(periodTypeToProviderSlugs)
    }

    _getFilteredProviderSlugs(periodTypeToProviderSlugs, facilityTypes) {
        return Object.entries(periodTypeToProviderSlugs)
            .filter(([key]) => facilityTypes.includes(key))
            .flatMap(([, providerSlugs]) => providerSlugs)
    }

    _getAllProviderSlugs(periodTypeToProviderSlugs) {
        return Object.values(periodTypeToProviderSlugs)
            .flatMap(providerSlugs => providerSlugs)
    }


    getQueryParamValueFromKeyStrings(keyStrings, isGoddard) {
        return isGoddard ? { values: keyStrings } : keyStrings
    }

    // Get the SQL report parameter to sort by
    getSortParameter() {
        return 'care_period_facility'
    }
}

export default ListTransformCarePeriodFacility
